import axiosInstance from "./axiosInstance";

const clientService = {
  fetchAllUsers: async (page, search = null, period = null, month = null, year = null) => {
    try {
      const params = new URLSearchParams();
      if (search) params.set("search", search);
      if (period === "today" || period === "month") params.set("period", period);
      if (period === "month" && month != null && month >= 1 && month <= 12) params.set("month", String(month));
      if (period === "month" && year != null && year >= 1900 && year <= 2100) params.set("year", String(year));
      const query = params.toString();
      const url = query
        ? `admin/users/all/${page}?${query}`
        : `admin/users/all/${page}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchCompletedUsers: async (page, search = null) => {
    try {
      const url = search
        ? `admin/users/completed/${page}?search=${encodeURIComponent(search)}`
        : `admin/users/completed/${page}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchAllPremiumUsers: async (page) => {
    try {
      const response = await axiosInstance.get("admin/users/premium/" + page);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  detailsUser: async (id) => {
    try {
      const response = await axiosInstance.get("admin/users/details/" + id);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  getFilteredUsersAdmin: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/filteredUsers",
        payload
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  fetchUserByEmail: async (identifier) => {
    try {
      // identifier can be either email or phone number
      const response = await axiosInstance.get(
        "admin/users/fetchUserByEmail/" + identifier
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  sendNotificationToFilteredUser: async (senderUserId, receiverUserId) => {
    try {
      const response = await axiosInstance.post(
        `admin/users/sendNotification/${senderUserId}/${receiverUserId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  /** App user (customer). Developer role only; see backend deleteAppUserByDeveloper. */
  deleteAppUserByDeveloper: async (userId) => {
    try {
      const response = await axiosInstance.delete(
        `admin/users/app-user/${userId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  /** App user (not admin panel user). Requires Admin role on token. */
  updateAppUserDetails: async (userId, body) => {
    try {
      const response = await axiosInstance.put(
        `admin/users/user-details/${userId}`,
        body
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  /** Minimal app user create (Admin / Developer / CSR). Optional imageUrl from upload endpoint. */
  createAppUser: async (body) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/create-app-user",
        body
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default clientService;
